import Chips from './components/Chips';
export type * from './types';

export default Chips;
